import React from 'react';
import { useTranslations } from '../../locales/useTranslations';
import FadeInAnimation from '../Common/FadeInAnimation';
import {
    BiQrScan,
    BiPalette,
    BiGlobe,
    BiCodeAlt,
    BiSpreadsheet,
    BiShieldQuarter,
} from 'react-icons/bi';

const QrFlowFeatures = () => {
    const { t } = useTranslations();

    const features = [
        { icon: <BiQrScan />, title: t('qrFlow_features_item1_title'), desc: t('qrFlow_features_item1_desc') },
        { icon: <BiPalette />, title: t('qrFlow_features_item2_title'), desc: t('qrFlow_features_item2_desc') },
        { icon: <BiGlobe />, title: t('qrFlow_features_item3_title'), desc: t('qrFlow_features_item3_desc') },
        { icon: <BiSpreadsheet />, title: t('qrFlow_features_item4_title'), desc: t('qrFlow_features_item4_desc') },
        { icon: <BiCodeAlt />, title: t('qrFlow_features_item5_title'), desc: t('qrFlow_features_item5_desc') },
        { icon: <BiShieldQuarter />, title: t('qrFlow_features_item6_title'), desc: t('qrFlow_features_item6_desc') },
    ];

    return (
        <section className="qr-flow-features" id="features">
            <div className="container">
                <FadeInAnimation direction="up" delay={50}>
                    <div className="qr-flow-features__intro">
                        <span className="qr-flow-features__badge">{t('qrFlow_features_badge')}</span>
                        <h2>{t('qrFlow_features_title')}</h2>
                        <p>{t('qrFlow_features_description')}</p>
                    </div>
                </FadeInAnimation>

                <div className="row g-4">
                    {features.map((feature, index) => (
                        <div key={index} className="col-lg-4 col-md-6">
                            <FadeInAnimation direction="up" delay={80 + index * 40}>
                                <article className="qr-flow-features__card">
                                    <div className="qr-flow-features__icon">{feature.icon}</div>
                                    <h3>{feature.title}</h3>
                                    <p>{feature.desc}</p>
                                </article>
                            </FadeInAnimation>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default QrFlowFeatures;
